import React from 'react';

export interface PanelSectionProps {
  title: string;
  description?: string;
  /** Rendered on the right of the header, e.g. an "Add" button. */
  action?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

/** Titled white card. Every panel is a stack of these. */
export const PanelSection: React.FC<PanelSectionProps> = ({
  title,
  description,
  action,
  children,
  className = '',
}) => (
  <section
    className={`rounded-2xl bg-white p-5 shadow-[0_2px_8px_rgba(0,0,0,0.08)] sm:p-6 ${className}`}
  >
    <header className="mb-4 flex items-start justify-between gap-4">
      <div>
        <h2 className="font-display text-xl text-[#333333]">{title}</h2>
        {description && <p className="mt-1 text-sm text-[#666666]">{description}</p>}
      </div>
      {action}
    </header>
    {children}
  </section>
);

export default PanelSection;
